import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { addGuestLastPlayed } from "../../features/slices/UserSlice";
import useFavouriteGame from "../common/useFavouriteGame";
import { buildPlayGameUrl } from "../../utils/playGameUrl";
import { getGameImage } from "../../utils/gameImage";
export function GamesCarousel(props) {
  const dispatch = useDispatch();
  const userLoggedIn = useSelector((state) => state.user.userLoggedIn);
  const { requestToggle, favouriteUI } = useFavouriteGame();
  const settings = {
    className: "slider",
    infinite: props.data.length > 4,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          className: "center",
          centerMode: true,
          slidesToShow: 2,
          infinite: props.data.length > 2,
          centerPadding: "5px",
          slidesToScroll: 1,
          speed: 500,
          dots: true,
          focusOnSelect: false,
        },
      },
    ],
  };

  return (
    <div>
      {favouriteUI}
      <div className="slider-custom-style">
        <Slider {...settings}>
          {props.data.map((item, index) => (
            <div className="slide-custom" key={item.id ?? index}>
              <a
                href={buildPlayGameUrl(item) || undefined}
                onClick={() => {
                  if (!userLoggedIn) dispatch(addGuestLastPlayed(item));
                }}
              >
                <div className="overlay">
                  <div className="game--name">
                    <p>{item.name}</p>
                  </div>
                  <i
                    className={`bi ${
                      props.fav || item.is_favorite ? "bi-star-fill" : "bi-star"
                    }`}
                    title={
                      props.fav || item.is_favorite
                        ? "Remove From Favourites"
                        : "Add To Favourites"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      requestToggle(item, props.fav || item.is_favorite);
                    }}
                  ></i>
                </div>

                <img
                  loading="lazy"
                  src={getGameImage(item)}
                  alt={item.name}
                />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
